/**
 * RESPONSIBILITY: the banner at the top of the Visit page.
 *
 * No @EditableBy, so WRITE defaults to NONE — admin only.
 */
import { Section, Text, Paragraph, Img } from '@framework/core/decorators';
import type { ImageValue } from '@framework/core';
import { SectionName } from '../section-names';
import { ABOVE_HINT } from '../hints';

@Section({ name: SectionName.VisitHero, label: 'Visit · Page head' })
export class VisitHeroSection {
  @Text({ label: 'Subtitle', maxLength: 120, default: 'Plan your visit', description: ABOVE_HINT })
  eyebrow!: string;

  @Text({ label: 'Title', maxLength: 300, default: 'Visit us' })
  heading!: string;

  @Paragraph({ label: 'Description', maxLength: 4000, rows: 3 })
  intro!: string;

  @Img({
    label: 'Image', folder: 'visit', maxSizeMb: 12, size: '1920 × 1080',
    description: 'Across the top of the page, behind the title.',
  })
  image!: ImageValue;
}
